import { forwardRef } from 'react';

import ChainIcon from '@/components/ChainIcon';
import { Button, ButtonProps } from '@/components/shadcn/ui/button';
import { cn } from '@/utils';
import { truncateMidAddressInputValue } from '@/utils/truncateAddress';

import { useSolanaWallet } from '../../../hooks/useSolanaWallet';

export const ConnectedSolanaWalletButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, children, ...props }, ref) => {
    const { address } = useSolanaWallet();
    const resultAddress = truncateMidAddressInputValue(address!);

    return (
      <Button
        ref={ref}
        size="sm"
        variant="secondary"
        className={cn('font-roboto rounded-xl font-bold', className)}
        {...props}
      >
        {children || (
          <div className="flex items-center gap-1 text-sm sm:gap-2">
            <ChainIcon src="/chains/solana.svg" />
            <div className="hidden sm:block">{resultAddress}</div>
          </div>
        )}
      </Button>
    );
  }
);

ConnectedSolanaWalletButton.displayName = 'SolanaButton';
